import React, {useEffect} from 'react';
import {
    bbDoesCustomerHaveAccessToSubscriptionLevel, bbFindCustomerTagsByTagId,
    bbFindEntityWithinPortfolioOrSelf, bbFindUserTagsByTagId,
    bbFormattedDateString, bbGetSubscriptionLevelPropertyFromIdOrName, bbGetSubscriptionPropertyFromIdOrName,
    bbIsEntityAwaitingFirstScoreCycle, isCurrentUserMemberOf, showBBNotification
} from "../../../util/bbHelpers";
import {Col, Row} from "reactstrap";
import PremiumCustomersOnlyWrapper from "./PremiumCustomersOnlyWrapper";
import BRSocialTestsTable from "./BRSocialTestsTable";
import {useDispatch, useSelector} from "react-redux";
import {fetchCycleSocialPagewise, fetchRiskCycleReport} from "../../../actions";
import {INFO} from "../../../constants/ActionTypes";
import testSocialCycleHistoryObject from "./testSocialCycleHistoryObject";
import Skeleton from "react-loading-skeleton";

const SocialCycleResponseSection = ({cycleId=null, portfolioView=false})=>{

    const testData = testSocialCycleHistoryObject;

    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView, loadingCycles, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");
    const applicableSubscriptionTypeId = bbGetSubscriptionPropertyFromIdOrName("BRfB", "id");
    const applicableSubscriptionLevelId = bbGetSubscriptionLevelPropertyFromIdOrName("lite", "id");
    const doesUserHaveALiteSubscriptionOrHigher = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, applicableSubscriptionTypeId, applicableSubscriptionLevelId, true);
    const hasPremiumSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 11);


    const lastCycleDateTime = myEntity && myEntity.settings && myEntity.settings.last_cycle_datetime;

    let historyData = myEntity
    && myEntity.history
        ? myEntity.history : null;
    // let historyData = testData;

    const historyDataWithSocialTests = myEntity
        && historyData
        && Array.isArray(historyData)
        && historyData
            .filter((cycle)=> cycle && cycle.social && cycle.social.tests && cycle.social.tests > 0);

    const hasMoreThanOneSocialCycle = historyDataWithSocialTests && historyDataWithSocialTests.length > 1;

    const cycleDetailsToView = myEntity && cycleId && myEntity.cycles && myEntity.cycles[cycleId];
    const socialDetails = myEntity && cycleDetailsToView && cycleDetailsToView.social;

    const dispatch = useDispatch();

    // console.log(cycleDetailsToView);

    useEffect(()=>{

        if(cycleId){
            if(myEntity
                && !loadingCycles[cycleId]
                && !cycleDetailsToView){
                dispatch(fetchRiskCycleReport({
                    cycleId: cycleId,
                    customerId: customerIdToUse
                }))
            }
            /***
             * Should NOT fetch if they have the "don't do social engineering" tag, which is ID of 80
             * https://breachbits.slack.com/archives/GSH388GM9/p1668545389712269
             ********************************** */



            const dontDoSocialTags = bbFindCustomerTagsByTagId(customer, 80);
            const dontDoSocial = dontDoSocialTags && dontDoSocialTags.length > 0; //if there is at least one dont social tag, then qualifies
            // console.log("checking for social tag within SocialCycleRepsonseSection.js", "customer", customer, "dontDoSocialTags", dontDoSocialTags, "dontDoSocial", dontDoSocial);
            const highestPageFetchedSocial = myEntity
                && myEntity.cycles
                && myEntity.cycles[cycleId]
                && myEntity.cycles[cycleId].social
                && myEntity.cycles[cycleId].social.cycleTotals
                && myEntity.cycles[cycleId].social.cycleTotals.highestPageFetched;

            const throttleSocialCall = !hasPremiumSubscription
                && (highestPageFetchedSocial >= 1);

            //only fetch if have Lite or higher
            if(myEntity
                && (authUser && !dontDoSocial)
                && cycleDetailsToView
                && !throttleSocialCall
                //TODO: restore this check for Lite subscription once we update such that all tiles on tech page only rely on summary data (see Slack convo https://breachbits.slack.com/archives/GLM5SQC2Z/p1657044367751359)
                // && (doesUserHaveALiteSubscriptionOrHigher || isAdmin || isStaff)
                && !loadingCycles[cycleId]
                && !loadingCycleSocial[cycleId]
            ){
                console.log("calling conditional on the social cycle response section")
                const social = myEntity.cycles[cycleId].social;

                let pageNumToFetch = null;
                const totalPages = social && social.cycleTotals && social.cycleTotals.pages;
                console.log("what is highestPageFetchedSocial", social && social.cycleTotals && social.cycleTotals.highestPageFetched, "for cycleId", cycleId)

                if(!social){
                    pageNumToFetch = 1;
                } else if (social.cycleTotals
                    && social.cycleTotals.pages
                    && social.cycleTotals.highestPageFetched
                    && social.cycleTotals.highestPageFetched < social.cycleTotals.pages){
                    pageNumToFetch = social.cycleTotals.highestPageFetched + 1;

                    console.log("pageNumber to Fetch being sent", pageNumToFetch)

                    //highestPageFetched needs to be added to local state to track better
                    // highestPageFetched = highestPageFetched + 1

                    // if(pageNumToFetch % 30 === 0){
                    //     const percentCompleteLoading = Math.floor(pageNumToFetch/totalPages * 100);
                    //     showBBNotification(INFO, "loading BreachRisk™ Social In Progress", `${percentCompleteLoading}% complete, now fetching segment ${pageNumToFetch} of ${totalPages}`, false);
                    // }
                }else if (
                    social.cycleTotals
                    && social.cycleTotals.pages
                    && social.cycleTotals.highestPageFetched
                    && social.cycleTotals.highestPageFetched >= social.cycleTotals.pages
                ){
                    console.log("All Social detail pages have been fetched. Won't fetch.", social.cycleTotals.highestPageFetched, "out of", totalPages);
                    pageNumToFetch=null;
                } else{
                    console.warn("BRSocialReports2 Unexpected reason to not fetch another social page. Will not fetch. social.meta", social ? social.cycleTotals : social, )
                    pageNumToFetch=null;

                }

                if(pageNumToFetch){
                    dispatch(fetchCycleSocialPagewise(
                        cycleId,
                        customerIdToUse,
                        myEntity.id,
                        pageNumToFetch,
                    ));
                }
            }
        }

    }, [cycleId, socialDetails, loadingCycleSocial, myEntity, loadingCycles, cycleDetailsToView]);

    return(
        <div>


            {hasMoreThanOneSocialCycle &&
                <div className={"mx-0 px-0"}>
                    <h3>Spearphishing Details For:{!bbIsEntityAwaitingFirstScoreCycle(myEntity) && <> {cycleDetailsToView && cycleDetailsToView.summary
                        ? bbFormattedDateString(cycleDetailsToView.summary.cycle_datetime, "shortFullMonth")
                        : bbFormattedDateString(lastCycleDateTime, "shortFullMonth")} </>}</h3>
                    <p></p>

                </div>
            }

            <Row>
                <Col>
                    <BRSocialTestsTable cycleId={cycleId} portfolioView={portfolioView}/>
                </Col>
            </Row>
        </div>
    )
}

export default SocialCycleResponseSection;
